import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.62 17h16M3.62 21h9M3.62 8c0-2.357 0-3.536.731-4.268C5.084 3 6.262 3 8.62 3h8c2.357 0 3.536 0 4.268.732s.732 1.911.732 4.268 0 3.536-.732 4.268-1.91.732-4.268.732h-8c-2.357 0-3.535 0-4.268-.732S3.62 10.357 3.62 8"
    }, null, -1)
  ])))
}
export default { render: render }